import React from 'react';
import PropTypes from 'prop-types';
import LoginLayout from '~/layout/LoginLayout';
import {LOGIN_TO} from '~/constant/login';
import LoginSuccess from '../components/LoginSuccess';
import WebLoginModal from './WebLoginModal';

const WebLogin = props => {
    const {to} = props;
    return (
        <LoginLayout >
            {to === LOGIN_TO.LOGIN_SUCCESS
                ? <LoginSuccess />
                : <WebLoginModal {...props} />}
        </LoginLayout>
    );

};

WebLogin.defaultProps = {
    isNeedToVerify: false,
    captchaId: '',
    phone: '',
    code: '',
    errMsg: '',
};

WebLogin.propTypes = {
    to: PropTypes.string.isRequired,
    isNeedToVerify: PropTypes.bool,
    captchaId: PropTypes.string,
    phone: PropTypes.string,
    code: PropTypes.string,
    errMsg: PropTypes.string,
    setErrMsg: PropTypes.func.isRequired,
    loginFunc: PropTypes.func.isRequired
};

export default WebLogin;
